// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"589":"a20171f0","787":"c7cd9c48","977":"d79d8caf"}[chunkId] + ".chunk.js";
};